import './easter-egg.scss';

import { SelectField } from 'fields/SelectField';
import { useEffect, useMemo, useState } from 'react';

import { useTypedSelector } from 'store';
import { Modal } from 'ui/Modal/Modal';

const SECRET_KEY = 'KeyF';
const GLOBAL_HOOK_KEY = '__mmFun__';
const VIDEO_OPTIONS = [
  {
    label: '3 girls 1 cup',
    src: 'https://www.youtube.com/embed/SkjidVxFUQ8?autoplay=1&mute=0',
  },
  {
    label: 'Alco run very fun',
    src: 'https://www.youtube.com/embed/6Dt7Z7TgdD4?autoplay=1&mute=0',
  },
  {
    label: 'Fluent english',
    src: 'https://www.youtube.com/embed/3W40tBACFbI?autoplay=1&mute=0',
  },
  {
    label: 'Alyona',
    src: 'https://www.youtube.com/embed/MGkWSAnoDOI?autoplay=1&mute=0',
  },
  {
    label: 'DeLegitimation',
    src: 'https://www.youtube.com/embed/Y_dd5aUY5S4?autoplay=1&mute=0',
  },
  {
    label: 'Claude funny moments',
    src: 'https://www.youtube.com/embed/efwDZw7l2Nk?autoplay=1&mute=0',
  },
  {
    label: 'Scalpers be like',
    src: 'https://www.youtube.com/embed/tvERE-Beu2U?autoplay=1&mute=0',
  },
  {
    label: 'Japanese showers',
    src: 'https://www.youtube.com/embed/N0c9heWCyZM?autoplay=1&mute=0',
  },
  {
    label: 'Never Gonna Give You Up',
    src: 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=0',
  },
  {
    label: 'Hypnotoad 10 hours',
    src: 'https://www.youtube.com/embed/zHU2RlSCdxU?autoplay=1&mute=0',
  },
  {
    label: 'Epic Sax Guy',
    src: 'https://www.youtube.com/embed/oiKj0Z_Xnjc?autoplay=1&mute=0',
  },
  {
    label: 'Airwolf Theme (synthwave)',
    src: 'https://www.youtube.com/embed/_W1P7AvV17w?autoplay=1&mute=0',
  },
  {
    label: 'Golden labrador post-punk remix',
    src: 'https://www.youtube.com/embed/RrHAxTdj3pM?autoplay=1&mute=0',
  },
  {
    label: 'Trade it all away 💸',
    src: 'https://youtube.com/embed/P0acGLqtLG4?autoplay=1&mute=0',
  },
  {
    label: 'Study 📖',
    src: 'https://www.youtube.com/embed/jWvn-aPFZZg?autoplay=1&mute=0',
  },
  {
    label: 'Finally we have tick chart 📈',
    src: 'https://www.youtube.com/embed/ExL8jClroLQ?autoplay=1&mute=0',
  },
];

type EasterEggApi = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

export function EasterEgg() {
  const isAdmin = useTypedSelector(store => store.auth.isAdmin);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(
    () => VIDEO_OPTIONS[Math.floor(Math.random() * VIDEO_OPTIONS.length)],
  );

  const keyboardHint = useMemo(() => 'Shift + Alt + Ctrl (or Cmd) + F', []);

  const pickRandomVideo = () => {
    const random = VIDEO_OPTIONS[Math.floor(Math.random() * VIDEO_OPTIONS.length)];
    setSelectedVideo(random);
  };

  useEffect(() => {
    if (!isAdmin) {
      setIsOpen(false);
      if ((window as any)[GLOBAL_HOOK_KEY]) {
        delete (window as any)[GLOBAL_HOOK_KEY];
      }
      return undefined;
    }

    const handleKeyboardToggle = (event: KeyboardEvent) => {
      const hasPrimaryModifier = event.ctrlKey || event.metaKey;
      if (event.code === SECRET_KEY && event.shiftKey && event.altKey && hasPrimaryModifier) {
        event.preventDefault();
        setIsOpen(prev => {
          if (!prev) {
            pickRandomVideo();
          }
          return !prev;
        });
      }
    };

    window.addEventListener('keydown', handleKeyboardToggle);

    const api: EasterEggApi = {
      open: () => {
        pickRandomVideo();
        setIsOpen(true);
      },
      close: () => setIsOpen(false),
      toggle: () =>
        setIsOpen(prev => {
          if (!prev) {
            pickRandomVideo();
          }
          return !prev;
        }),
    };

    (window as any)[GLOBAL_HOOK_KEY] = api;

    return () => {
      window.removeEventListener('keydown', handleKeyboardToggle);
      if ((window as any)[GLOBAL_HOOK_KEY] === api) {
        delete (window as any)[GLOBAL_HOOK_KEY];
      }
    };
  }, [isAdmin]);

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      {isOpen && (
        <Modal
          title={
            <div className="flex items-center justify-start gap-2">
              <img src="/images/blue-head-with-ligth.png" alt="Skull Icon" className="w-6 h-8" />{' '}
              <h3>Admin fun corner</h3>
            </div>
          }
          onClose={() => setIsOpen(false)}
          className="max-w-4xl"
          backdropClassName="mm-egg-backdrop"
        >
          <div className="flex flex-col gap-4 text-gray-100">
            <p className="text-sm text-gray-300">
              You found a small admin-only easter egg. Use the secret keyboard combo or call
              <code className="mx-1 rounded bg-gray-800 px-1 py-0.5 text-xs">
                window.{GLOBAL_HOOK_KEY}.open()
              </code>
              in the console to reopen it.
            </p>

            <div
              className="relative w-full overflow-hidden rounded-xl shadow-lg"
              style={{ paddingBottom: '56.25%', backgroundColor: '#0b1224' }}
            >
              <iframe
                title="MM Dashboard fun break"
                src={selectedVideo.src}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="absolute inset-0 h-full w-full border-0"
              />
            </div>

            <div className="flex flex-col gap-2 text-xs text-gray-300">
              <label htmlFor="egg-video-select" className="text-xs text-gray-200">
                Choose video
              </label>
              <SelectField
                id="egg-video-select"
                className="w-full"
                items={VIDEO_OPTIONS}
                itemToString={option => option.label}
                selectedItem={selectedVideo}
                onSelectItem={option => setSelectedVideo(option ?? VIDEO_OPTIONS[0])}
                placeholder="Choose video"
              />
            </div>

            <div className="flex flex-wrap items-center gap-2 text-xs text-gray-400">
              <span className="rounded border border-gray-700 bg-gray-900 px-2 py-1">
                {keyboardHint}
              </span>
              <span>or run</span>
              <code className="rounded bg-gray-800 px-1 py-0.5 text-[11px]">
                window.{GLOBAL_HOOK_KEY}.toggle()
              </code>
              <span>in the console.</span>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default EasterEgg;
